import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Alert, Button, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { ConnectEsigningProviderDialog } from 'app/domains/esigning/components/ConnectEsigningProviderDialog';
import { useEsigningProviders } from 'app/domains/esigning/hooks/useEsigningProviders';
import { SectionContent } from '../../components';
export function ConnectProviderState() {
    const { isConnectedProviderExpired } = useEsigningProviders();
    const [showConnectDialog, setShowConnectDialog] = useState(false);
    const showDialog = () => setShowConnectDialog(true);
    const hideDialog = () => setShowConnectDialog(false);
    return (<SectionContent>
      {showConnectDialog && <ConnectEsigningProviderDialog onClose={hideDialog}/>}
      {isConnectedProviderExpired && (<Alert appearance="info" message={t({
                message: "Since you haven't used e-signing in more than 30 days you need to authenticate.",
                comment: 'Message for when the e-signing provider connection has expired and the user needs to reconnect',
            })}/>)}
      <EmptyState withAvatar icon={<Falcon icon="paper-plane"/>} title={t({
            comment: 'No e-signing provider has been selected - title',
            message: 'Select e-signing provider',
        })} description={t({
            comment: 'No e-signing provider has been selected - message',
            message: 'To start using e-signing you need to select an e-signing provider',
        })} actions={<Button onClick={showDialog}>
            <Trans comment="No e-signing provider has been selected - call to action label">Select provider</Trans>
          </Button>}/>
    </SectionContent>);
}
